import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';

import type { ApiMode } from '@/config/runtime';
import { runtimeConfig } from '@/config/runtime';
import { useTheme } from '@/hooks/useTheme';

import CommandPalette from './CommandPalette';
import NewsTicker from './NewsTicker';
import TopNav from './TopNav';

function PageLoadingFallback() {
  return (
    <div
      className="flex min-h-[calc(100dvh-6rem)] items-center justify-center bg-surface-50"
      role="status"
    >
      <span className="flex items-center gap-2 text-sm text-surface-500">
        <i className="ri-loader-4-line animate-spin text-xl" aria-hidden="true" />
        Загрузка...
      </span>
    </div>
  );
}

interface AppShellProps {
  apiMode?: ApiMode;
}

export default function AppShell({ apiMode = runtimeConfig.apiMode }: AppShellProps) {
  const [commandOpen, setCommandOpen] = useState(false);
  const { theme, toggle } = useTheme();

  return (
    <div className="min-h-dvh bg-surface-50 transition-colors duration-200">
      <div className="sticky top-0 z-40 flex max-h-[100vh] min-h-0 flex-col supports-[height:100dvh]:max-h-[100dvh]">
        <TopNav onOpenCommand={() => setCommandOpen(true)} theme={theme} onToggleTheme={toggle} />
        {apiMode === 'mock' && <NewsTicker />}
      </div>

      <Suspense fallback={<PageLoadingFallback />}>
        <Outlet />
      </Suspense>

      <CommandPalette open={commandOpen} setOpen={setCommandOpen} />
    </div>
  );
}
